/**
 * Capitalizes the first letter of every word as it's typed, task: job title
 * auto-capitalization (2026-09-24). Used on the Title field, both at capture
 * (MeetingForm.jsx) and on Edit Contact (EditContact.jsx), so "director of
 * operations" becomes "Director Of Operations" without a rep reaching for
 * shift. Same one-formatter-per-input-field pattern as phone.js's own
 * formatPhoneAsTyped: applied in the field's onChange, called with the
 * value the rep just typed, stored value is whatever this returns.
 *
 * Only ever uppercases a letter, never lowercases or removes one: unlike
 * worker/lib/messages.ts's own toTitleCase (which lowercases the whole
 * string first, fine for a first name, never meant for this), a title
 * already carrying its own intentional capitals ("VP of Sales", "IT
 * Director") survives exactly as typed rather than becoming "Vp Of Sales"
 * or "It Director". worker/lib/badge.ts documents the identical reasoning
 * for names: blindly lowercasing first is the wrong default the moment a
 * real capital was already there on purpose.
 *
 * \b\w matches the first word character of every whitespace or
 * punctuation-delimited run, the exact regex messages.ts's own toTitleCase
 * already uses for the same purpose, just without the lowercase-first step:
 * "co-founder" becomes "Co-Founder", "o'brien" becomes "O'Brien", matching
 * the same word boundaries a browser's own CSS text-transform: capitalize
 * would use.
 */
export function capitalizeWords(value) {
  return value ? value.replace(/\b\w/g, (c) => c.toUpperCase()) : value;
}
